import { render, staticRenderFns } from "./addRelationsDialog.vue?vue&type=template&id=4804ef03&scoped=true"
import script from "./addRelationsDialog.vue?vue&type=script&lang=js"
export * from "./addRelationsDialog.vue?vue&type=script&lang=js"
import style0 from "./addRelationsDialog.vue?vue&type=style&index=0&id=4804ef03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4804ef03",
  null
  
)

export default component.exports